import {Cureus} from '../Cureus';

Cureus.AdminAuthorStatsTable = {};

//= require_tree ./AdminAuthorStatsTable
